import './Profile.css'
import { UserProfile, Library } from '../../sections/index'


const Profile = () => {
    return (
        <>
            <UserProfile />
            <Library />
        </>
    )
}

export default Profile